export default "__VITE_ASSET__Ct02v9mP__"